import { createAction, createSlice } from "@reduxjs/toolkit";

const codeValidatorSlice = createSlice({
  name: "codeValidator",
  initialState: { success: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.success = true;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.success = false;
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = codeValidatorSlice;
const codeValidatorAction = createAction(name);

export {
  codeValidatorAction,
  actions as codeValidatorActions,
  reducer as codeValidatorReducer,
};
